import type { Platform } from "./types";

export function detectPlatform(input: string): Exclude<Platform, "auto"> {
  try {
    const host = new URL(input).hostname.toLowerCase();
    if (host === "xiaohongshu.com" || host.endsWith(".xiaohongshu.com")) {
      return "xiaohongshu";
    }
    if (host === "xhslink.com" || host.endsWith(".xhslink.com")) {
      return "xiaohongshu";
    }
    if (host === "goofish.com" || host.endsWith(".goofish.com")) {
      return "xianyu";
    }
    if (host === "2.taobao.com" || host.endsWith(".2.taobao.com")) {
      return "xianyu";
    }
    return "generic";
  } catch {
    return "generic";
  }
}

export const platformLabel: Record<Exclude<Platform, "auto">, string> = {
  generic: "通用网页",
  xiaohongshu: "小红书",
  xianyu: "闲鱼",
};

export function targetLabel(target: "xiaohongshu" | "xianyu"): string {
  return target === "xiaohongshu" ? "小红书图文笔记" : "闲鱼商品介绍";
}
